import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const getUserAccountsRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_CMS_ACCOUNT_DELETE,
        params: params,
    });
};

export const postDeleteUserAccountRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.POST_CMS_ACCOUNT_DELETE,
        data: data,
    });
};

export const postLogoutUserAccountRepo = (data) => {
    return axios({
        baseURL: ServiceUrls.CUS_SERVICE + process.env.REACT_APP_SUB_DOMAIN_NAME,
        method: "POST",
        url: Urls.POST_CMS_USER_LOGOUT,
        data: data,
    });
};
  
//   export const deleteMessagingContentRepo  = (id, data) => {
//     return axios({
//       method: 'DELETE',
//       url: Urls.PUT_CMS_MESSAGING_CONTENT + id + '/',
//       data: data
//     })
//   }

